import { Button } from '@/components/common/Button';
import { FlexCol, FlexRow } from '@/components/common/Flex';
import { Paragraph } from '@/components/common/Typography';
import { Spacer, useBreakpointValue } from '@chakra-ui/react';
import { useExportActionText } from '@common/react/export/useExportActionText';
import { useCurrentUser } from '@common/react/user';
import { useRouter } from 'next/router';
import useLocalStorageState from 'use-local-storage-state';

export const SHUTDOWN_BANNER_HEIGHT = 20;

export const ShutdownBanner = () => {
    const [isDismissed, setIsDismissed] = useIsShutdownBannerDismissed();
    const actionText = useExportActionText();
    const router = useRouter();
    const isMediumScreen = useBreakpointValue(
        {
            base: false,
            md: true,
        },
        {
            fallback: 'base',
            ssr: true,
        }
    );

    if (isDismissed) return null;

    return (
        <FlexRow
            bg="blue.500"
            h={SHUTDOWN_BANNER_HEIGHT}
            color="white"
            align="center"
            px={8}
            py={5}
            position="fixed"
            top={0}
            left={0}
            right={0}
            zIndex={1300}
            mb={SHUTDOWN_BANNER_HEIGHT}
        >
            <FlexCol>
                <Paragraph fontWeight="semibold">
                    Plenty is closing - Take action now
                </Paragraph>
                {isMediumScreen && (
                    <Paragraph fontSize="sm" opacity={0.8}>
                        We’re closing operations soon. Please withdraw your
                        funds and export your data before Plenty closes.
                    </Paragraph>
                )}
            </FlexCol>
            <Spacer />
            <Button
                onClickEvent="Acknowledge Shutdown Button Clicked"
                variant="ghost"
                colorScheme="white"
                onClick={() => setIsDismissed(true)}
            >
                Acknowledge
            </Button>
            <Button
                onClickEvent="Withdraw & Export Button Clicked"
                colorScheme="white"
                variant="outline"
                h={11}
                w={170}
                onClick={() => router.push('/export')}
            >
                {actionText}
            </Button>
        </FlexRow>
    );
};

export const useIsShutdownBannerVisible = () => {
    const { featureFlags } = useCurrentUser();
    const [isDismissed] = useIsShutdownBannerDismissed();

    return featureFlags.isShutdownV1Enabled && !isDismissed;
};

const useIsShutdownBannerDismissed = () =>
    useLocalStorageState<boolean | undefined>('isShutdownBannerDismissed');
